// Layout of Account (spec 08 § 1, D182 (4)): `/account/<section>` behind the avatar, no context of its own — the shell
// is the context the person was in last, with no section current. From 840 px the Account sections sit beside the
// open page; below it the Profile page lists them. Below 600 px the person's glacier (name, email and roles, account-hub) stands
// where the shell draws the context's.
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet, useMatch } from '@tanstack/react-router'
import { AccountHeader } from '../../features/account/AccountHeader'
import { AccountSections } from '../../features/account/AccountSections'
import { meQuery } from '../../shared/org/me'
import { AppShell } from '../../shared/shell/AppShell'
import { useLastContext } from '../../shared/shell/lastContext'
import { useWindowClass } from '../../shared/shell/useWindowClass'

export const Route = createFileRoute('/account')({
  // Guard (signed in): the session and access come from the query cache; a failed check redirects
  // to /sign-in?next=… or renders NotFound for an organization the person is not in (spec 08 § 5).
  beforeLoad: () => {},
  staticData: { workspace: 'me' },
  component: AccountLayout,
})

function AccountLayout() {
  // About opens signed out too (screens.json `session: any`): without a session it stands alone, as before A12P13.
  const about = useMatch({ from: '/account/about', shouldThrow: false })
  const { data: me } = useQuery({ ...meQuery(), enabled: false })
  const context = useLastContext()
  const windowClass = useWindowClass()
  if (about && !me) return <Outlet />
  const beside = windowClass === 'expanded' || windowClass === 'wide'
  return (
    <AppShell {...context} header={<AccountHeader className="mb-(--inset-lg)" />}>
      {beside ? (
        <div className="flex items-start gap-(--inset-xl)">
          <AccountSections className="sticky top-(--inset-lg) w-80 shrink-0" />
          <div className="min-w-0 max-w-2xl flex-1">
            <Outlet />
          </div>
        </div>
      ) : (
        <Outlet />
      )}
    </AppShell>
  )
}
